import React from "react";
import { ClockIcon, FilesIcon, HelpCircleIcon, MapIcon, RotateCcwIcon, SearchIcon, BoxIcon } from "lucide-react";
import { painPoints, PainIcon } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
const iconMap: Record<PainIcon, BoxIcon> = {
  chart: MapIcon,
  search: SearchIcon,
  unsure: HelpCircleIcon,
  clock: ClockIcon,
  files: FilesIcon,
  repeat: RotateCcwIcon
};
export function Recognize() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="recognize-title" data-id="element-267" data-mp="3k2aeard7tg06">
      <div id="recognize-title" data-id="element-268" data-mp="3629ezgclmgmt">
        <SectionHeading title={<>
              Do you recognize yourself in <em className="italic text-brand-600" data-id="element-270" data-mp="3a3bi489mzcu2">any of these situations?</em>
            </>} data-id="element-269" data-mp="36317giawfy8v" />
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-3 md:grid-cols-2" data-id="element-271" data-mp="14a3e8ld7n3ne">
        {painPoints.map(({
        icon,
        text
      }) => {
        const Icon = iconMap[icon];
        return <li key={text} className="flex gap-4 rounded-2xl bg-cream p-5" data-id="element-272" data-mp="1ifqlkusq8ejt">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-100 text-brand-700" data-id="element-273" data-mp="1dh5miyp7o0wy">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-274" data-mp="1s6ldaeoqs6cn" />
              </span>
              <p className="text-[17px] leading-snug text-ink/85" data-id="element-275" data-mp="1n78p9qm4wt8h">{text}</p>
            </li>;
      })}
      </ul>

      <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-brand-800 px-6 py-9 text-center text-white sm:px-10" data-id="element-276" data-mp="zgusjmslu67k">
        <p className="text-lg text-brand-100" data-id="element-277" data-mp="ujcuirg4lbec">And it doesn't have to be this way.</p>
        <p className="mt-3 text-lg text-brand-100" data-id="element-278" data-mp="19g3mifngzktx">Because the problem isn't always a lack of information.</p>
        <p className="mt-4 font-serif text-3xl font-black leading-tight sm:text-4xl" data-id="element-279" data-mp="14g7p4z9a2rnc">
          Sometimes the problem is the lack of a <span className="text-brand-300" data-id="element-280" data-mp="2kt62b8hqw6d1">SYSTEM.</span>
        </p>
        <p className="mt-6 text-lg leading-relaxed text-brand-50" data-id="element-281" data-mp="2fwfm8l5xxarm">
          I took the maps, reference materials, sequences, protocols, worksheets, and checklists and organized them into
          one visual system. So instead of constantly searching… you can simply open your system and reference what you
          need.
        </p>
      </div>

      <TransformCta label="Yes! Give me the complete system" data-id="element-282" data-mp="2wuxk5ugc128s" />
    </section>;
}